import { gql } from 'graphql-request'

export namespace RentalApplicationQueries {
  export const QUERY_KEY = 'getRentalApplication'

  export function getRentalApplication() {
    return gql`
      query getRentalApplication($id: Int!) {
        rentalApplication(id: $id) {
          needParking
          hasPets

          vehicle2Type
          vehicle2Make
          vehicle2Model
          vehicle2Year
          vehicle2State
          vehicle2LicensePlate
          vehicle2ParkingSelection

          vehicleType
          vehicleMake
          vehicleModel
          vehicleYear
          vehicleState
          vehicleLicensePlate
          vehicleParkingSelection

          organizationId

          pet1Name
          pet1Age
          pet1Type
          pet1Breed
          pet1Color
          pet1ServiceAnimal
          pet1Weight

          pet2Name
          pet2Type
          pet2Age
          pet2Breed
          pet2Color
          pet2Weight
          pet2ServiceAnimal

          occupants {
            name
            email
            phoneNumber
            dateOfBirth
          }
        }
      }
    `
  }
}
